/*
  Kinetic Membership: one per order.
  A cart with 2 memberships went to checkout at $60 (abandoned cart, Oct 3 2026). The membership is a
  Seal subscription line (selling plan), so any line with a selling plan, or the Kinetic Membership product,
  is held at quantity 1:
    - after a product is added (ajaxProduct:added) and after any cart change (cart:updated),
    - when a page with the cart loads,
    - right before checkout (a click on any checkout button or link waits for the check).
  The cart page and drawer also lock the quantity box for these lines (main-cart / cart-drawer Liquid).
  Loaded from sections/cart-drawer.liquid and sections/main-cart.liquid; the flag stops a double start.
*/
(function () {
  if (window.kcMembershipQty) return;
  window.kcMembershipQty = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = null;

  function isMembership(item) {
    return !!item.selling_plan_allocation || item.product_title === 'Kinetic Membership';
  }

  function clamp() {
    if (busy) return busy;
    busy = fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var over = (cart.items || []).filter(function (it) { return isMembership(it) && it.quantity > 1; });
        return over.reduce(function (p, it) {
          return p.then(function () {
            return fetch(root + 'cart/change.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: it.key, quantity: 1 })
            });
          });
        }, Promise.resolve()).then(function () { return over.length > 0; });
      })
      .catch(function () { return false; })
      .then(function (changed) { busy = null; return changed; });
    return busy;
  }

  function refresh(open) {
    if (/\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: open } }));
    }
  }

  document.addEventListener('ajaxProduct:added', function () { clamp().then(function (c) { if (c) refresh(true); }); });
  document.addEventListener('cart:updated', function () { clamp().then(function (c) { if (c) refresh(false); }); });

  function onLoad() { clamp().then(function (c) { if (c) refresh(false); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onLoad); else onLoad();

  // Checkout from the drawer (or a checkout link) waits for the check, then the same button is clicked again.
  // The cart page form is left alone: it posts every line's quantity and the locked line always sends 1.
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]');
    if (!t || t.hasAttribute('data-kc-qty-checked')) return;
    if (t.form && t.form.id === 'cart') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    clamp().then(function () {
      t.setAttribute('data-kc-qty-checked', '');
      t.click();
      setTimeout(function () { t.removeAttribute('data-kc-qty-checked'); }, 2000);
    });
  }, true);
})();
